export type Environment = 'dev' | 'dev-shared' | 'prod';

// Reads the build-time-injected `LORE_BUILD_ENV` token. The release
// workflow passes `--define:process.env.LORE_BUILD_ENV='"prod"'` to
// esbuild so the published bundle has 'prod' substituted inline; in
// local dev (`pnpm build` / `tsx`) the env var is undefined and we
// fall back to 'dev'.
const CURRENT_ENVIRONMENT: Environment =
  (process.env.LORE_BUILD_ENV as Environment | undefined) ?? 'dev';

// The CLI release workflow runs `npm version ...` in apps/cli before the
// prod esbuild step. The build script then inlines that stamped package
// version as `LORE_CLI_VERSION`; local pnpm/tsx runs fall back to the
// package-version env var that pnpm sets for scripts.
const CLI_VERSION =
  process.env.LORE_CLI_VERSION ?? process.env.npm_package_version ?? 'dev';
const CLI_USER_AGENT = `@loredotlink/cli/${CLI_VERSION}`;

export function getCurrentEnvironment(): Environment {
  return CURRENT_ENVIRONMENT;
}

export function getCliVersion(): string {
  return CLI_VERSION;
}

export function getCliUserAgent(): string {
  return CLI_USER_AGENT;
}
